module.exports = __webpack_public_path__ + "img/channenshipping-ico.eb47b0b8.svg";